import { render, staticRenderFns } from "./TheDetails.vue?vue&type=template&id=4b533d75&scoped=true"
import script from "./TheDetails.vue?vue&type=script&lang=ts"
export * from "./TheDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b533d75",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShowDetailsTheDescription: require('/usr/src/nuxt-app/components/show/details/TheDescription.vue').default,ShowDetailsTheDocuments: require('/usr/src/nuxt-app/components/show/details/TheDocuments.vue').default})
